/* eslint-disable max-len */
import { Auth } from "aws-amplify";
import axios from "axios";
import { authHeader } from "../CommonMethods/Auth-Headers";
import { handleSessionError } from '../CommonMethods/handleSessionError'
import { getAuthItem } from '../CommonMethods/authSession';

const { baseURL } = require("../config");


async function login(email, password,browserId) {
    let payload = {
        user_name: email,
        password: password,
        browser_id: browserId.toString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}providers/login`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function resetPassword(email,payload) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}providers/reset-password/${email}`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}


async function verifyPreference(payload) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}providers/verify-preference`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function verifyOtp(payload) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}providers/preference`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function preferenceList() {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.get(`${baseURL}providers/preference`,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function trustMyBrowser(body) {
    const idToken = sessionStorage.getItem("IdToken");
    const id = sessionStorage.getItem("id");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}providers/trust-browser/${id}`,body,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function trustMyBrowserMonitor(body) {
    const idToken = sessionStorage.getItem("IdToken");
    const id = sessionStorage.getItem("id");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}providers/trust-browser/${id}`,body,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}


async function sendOtptoPreference(preference_id) {
    const sessionToken = sessionStorage.getItem("session_token");
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}providers/login/send-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function resendOtp(preference_id) {
    const sessionToken = sessionStorage.getItem("session_token");
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        type: "resend-otp",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}providers/login/send-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function verifyLoginOtp(otp) {
    const sessionToken = sessionStorage.getItem("verify_otp_session_token");
    let payload = {
        session_token: sessionToken,
        otp: otp,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}providers/login/verify-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, message: error }
    }
}

async function logout() {
    // Use getAuthItem to get tokens from both storages (prioritizes sessionStorage, falls back to localStorage)
    const idToken = getAuthItem("IdToken");
    const refreshToken = getAuthItem("RefreshToken");
    
    // Ensure we have valid tokens before attempting logout
    if (!idToken || !refreshToken) {
        return {error: true, message: 'No valid tokens found for logout'};
    }
    
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        // Use type=clear-session to ensure all sessions are cleared, not just the current one
        // This is especially important when logging out from child tabs
        const data = await axios.post(`${baseURL}providers/logout?type=clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}


async function deletePreference(_id) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.delete(`${baseURL}providers/delete-preference/${_id}`,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

async function forgotPasswordLink(username) {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const url = `${baseURL}providers/forgot-password-send-link/${username}?timezone=${encodeURIComponent(timezone)}`;
        const data = await axios.post(url);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function forgotPassword(body) {
    try {
        const data = await axios.patch(`${baseURL}providers/forgot-password-verify`, body);
        return {error: false, data: data.data};
    } catch (error) {
        return handleSessionError(error);
    }
}

// async function checkStatus() {
//     const idToken = sessionStorage.getItem("IdToken");
//     const headers = {
//         Authorization: `Bearer ${idToken}`,
//     };
//     try {
//         const data = await axios.get(`${baseURL}organization-users/login-status`,{
//             headers: headers,
//         });
//         return {error: false, data: data.data};
//     } catch (error) {
//         return handleSessionError(error);
//     }
// }

async function RefreshToken() {
    const idToken = sessionStorage.getItem("IdToken");
    const refreshToken = sessionStorage.getItem("RefreshToken");
    const body = {
        refresh_token: refreshToken
    }
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}providers/refresh-token`, body ,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function DuplicateTabClose() {
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}users/clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function DuplicateLogout() {
    const idToken = getAuthItem("IdToken");
    const refreshToken = getAuthItem("RefreshToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}providers/logout?type=clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function CancelDuplicatelogin() {
    let payload = {
        user_name: getAuthItem("email"),
        user_type: getAuthItem("user_type") === "monitor-user" ? "monitor" : "provider",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/capture-log`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

export const userService = {
    login,
    resetPassword,
    verifyPreference,
    verifyOtp,
    preferenceList,
    sendOtptoPreference,
    verifyLoginOtp,
    logout,
    trustMyBrowser,
    deletePreference,
    forgotPasswordLink,
    forgotPassword,
    resendOtp,
    // checkStatus,
    RefreshToken,
    trustMyBrowserMonitor,
    DuplicateTabClose,
    DuplicateLogout,
    CancelDuplicatelogin,
}
